import React, { useState } from "react";
import { Space, Tooltip, message } from "antd";
import { CopyOutlined, FilePdfOutlined, FileTextOutlined } from "@ant-design/icons";
import { ButtonItem } from "../../../Components/Items";
import { pedirReporte, descargarPdfBase64, descargarTexto, copiarAlPortapapeles } from "./utilsPerformance";

/**
 * PDF, copiar texto y descargar .txt del reporte de saturación. El texto es el mismo que
 * se adjunta al correo: está pensado para pegarse completo en Claude.
 *
 * @param {string} endpoint  "performance/alertas/reporte" o "performance/recursos/reporte"
 * @param {object} cuerpo    { alertaId } o { snapshotId }
 */
const BotonesReporte = ({ endpoint, cuerpo, headersToken }) => {
    const [cargando, setCargando] = useState(null);

    const ejecutar = async (accion, e) => {
        // En una tabla con onRow, el clic no debe abrir también el renglón.
        if (e && e.stopPropagation) e.stopPropagation();
        setCargando(accion);
        try {
            if (accion === "pdf") {
                const data = await pedirReporte(endpoint, cuerpo, "pdf", headersToken);
                descargarPdfBase64(data.base64, data.nombreArchivo);
                return;
            }

            const data = await pedirReporte(endpoint, cuerpo, "texto", headersToken);
            if (accion === "txt") {
                descargarTexto(data.texto, data.nombreArchivo);
                return;
            }
            if (await copiarAlPortapapeles(data.texto)) {
                message.success("Reporte copiado: pégalo directo en Claude");
            } else {
                descargarTexto(data.texto, data.nombreArchivo);
                message.warning("El navegador no dejó copiar; se descargó el .txt");
            }
        } catch (err) {
            message.error(err.message || "No se pudo generar el reporte");
        } finally {
            setCargando(null);
        }
    };

    return (
        <Space size={4} onClick={(e) => e.stopPropagation()}>
            <Tooltip title="Descargar el reporte en PDF">
                <ButtonItem
                    blanco
                    size="small"
                    icon={<FilePdfOutlined />}
                    loading={cargando === "pdf"}
                    onClick={(e) => ejecutar("pdf", e)}
                >
                    PDF
                </ButtonItem>
            </Tooltip>
            <Tooltip title="Copiar el reporte en texto para pegarlo en Claude">
                <ButtonItem
                    blanco
                    size="small"
                    icon={<CopyOutlined />}
                    loading={cargando === "copiar"}
                    onClick={(e) => ejecutar("copiar", e)}
                >
                    Copiar texto
                </ButtonItem>
            </Tooltip>
            <Tooltip title="Descargar el reporte en texto (.txt)">
                <ButtonItem
                    blanco
                    size="small"
                    icon={<FileTextOutlined />}
                    loading={cargando === "txt"}
                    onClick={(e) => ejecutar("txt", e)}
                >
                    .txt
                </ButtonItem>
            </Tooltip>
        </Space>
    );
};

export default BotonesReporte;
